import React, { useCallback, useRef, useState } from 'react';
import { promptDialog } from './dialog';
import { toast } from './toast';

// 点击复制标识 (toolKey / device_key 等) 的共用钩子:
// 复制成功后 toast「已复制」并短暂回显 ✓, clipboard 不可用 (非 https / 浏览器禁用) 时退回弹窗让人手动选中.
// 列表行常带跳转, 所以默认阻止冒泡, 点复制不会顺带打开详情.
export function useCopyText(resetMs = 1500) {
    const [copied, setCopied] = useState('');
    const timer = useRef<number>();

    const copy = useCallback(
        async (e: React.MouseEvent | undefined, text: string) => {
            e?.stopPropagation();
            if (!text) return;
            try {
                await navigator.clipboard.writeText(text);
                toast(`已复制 ${text}`);
                setCopied(text);
                window.clearTimeout(timer.current);
                timer.current = window.setTimeout(() => setCopied(''), resetMs);
            } catch {
                await promptDialog('复制失败, 请手动复制:', text);
            }
        },
        [resetMs],
    );

    return { copied, copy };
}
